import React, { Fragment } from 'react'
import { array, func, string } from 'prop-types'
import LazyLoad from 'react-lazyload'

import typography from '../../utils/typography'
import media from '../../utils/style'
import { Box } from 'rebass'
import styled from 'styled-components'
import VehicleListingFilterCard from '../VehicleListingFilterCard'
import formatMileage from '../../../lib/mileage-formatter'
import buildImageUrl from '../../../lib/media-url-maker'
import { Image, Heading } from 'rebass'
import IconClose from '../../vectors/IconClose'
import carIllustration from '../../images/car-illustration.png'
import vanIllustration from '../../images/van-illustration.png'
import generateFinanceData from '../../lib/finance-data-generator'

const Results = styled(Box)`
  min-height: 1000px;
  margin-bottom: ${typography.rhythm(0.5)};
  ${media.LargeScreenUp`
    margin-bottom: ${typography.rhythm(3.5)};
  `};
`

const NoResults = styled.div`
  margin: auto;
  max-width: 650px;
  text-align: center;
`

const NoResultsImage = styled.div`
  margin: auto;
  max-width: 450px;
  position: relative;

  img {
    margin-bottom: 0;
  }
`

const NoResultsIcon = styled.div`
  background: ${(props) => props.theme.colors.blue_light};
  border: 1px solid ${(props) => props.theme.colors.blue};
  border-radius: 100%;
  height: 45px;
  width: 45px;
  padding: 6px;
  position: absolute;
  top: 20px;
  right: 70px;

  svg {
    width: 16px;
    height: auto;
  }
`

const createVehicleCard = (key, onInfoOpen, onRecentFavourite) => {
  const querystring =
    (typeof window !== 'undefined' && window.location.search) || ''

  const VehicleCard = (vehicle, i) => {
    const { finance, vehiclePayment } = generateFinanceData(vehicle)
    return (
      <VehicleListingFilterCard
        key={`vehicle-${key}-${i}`}
        id={vehicle.id}
        image={buildImageUrl({
          resource: vehicle.image,
          width: 600,
          height: 400
        })}
        model={vehicle.model}
        brand={vehicle.brand}
        derivative={vehicle.derivative}
        finance={finance}
        offer={vehicle.onOffer}
        offerTitle={vehicle.offerTitle}
        offerDescription={vehicle.offerDescription}
        details={[
          vehicle.year,
          formatMileage(vehicle.mileage),
          vehicle.colour,
          vehicle.transmission,
          vehicle.fuel
        ]}
        price={vehiclePayment}
        path={vehicle.path + querystring}
        reserved={!!vehicle.reservedDate}
        isSold={vehicle.isSold}
        expiredDate={vehicle.expiredDate}
        onRecentFavourite={onRecentFavourite}
        onInfoOpen={onInfoOpen}
      />
    )
  }

  return VehicleCard
}

const chunk = (array, size) => {
  const len = array.length
  const returnArray = []
  for (let i = 0; i < len; i += size) {
    returnArray.push(array.slice(i, i + size))
  }
  return returnArray
}

class VehicleListingFilterResults extends React.PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    const { onInfoOpen, onRecentFavourite, vehicles, vehicleType } = this.props
    const allChunks = chunk(vehicles, 20)
    return (
      <Results mx={['5%', '10%', '5%', '10%']} pb={20}>
        {vehicles.length > 0 ? (
          <div>
            {allChunks[0] &&
              allChunks[0].map(
                createVehicleCard(`chunk-${0}`, onInfoOpen, onRecentFavourite)
              )}
            {allChunks.slice(1).map((chunk, i) => (
              <LazyLoad key={`used-lazy-${i}`} height={254}>
                <Fragment>
                  {chunk.map(
                    createVehicleCard(
                      `chunk-${i}`,
                      onInfoOpen,
                      onRecentFavourite
                    )
                  )}
                </Fragment>
              </LazyLoad>
            ))}
          </div>
        ) : (
          <NoResults>
            <NoResultsImage>
              <Image
                src={vehicleType === 'van' ? vanIllustration : carIllustration}
                alt=""
              />
              <NoResultsIcon>
                <IconClose />
              </NoResultsIcon>
            </NoResultsImage>
            <Heading as="h2" fontSize={7} mb={3}>
              Sorry, we couldn’t find the {vehicleType} you’re looking for
            </Heading>
            <p>
              Try clearing all or some of your filters to widen your selection
              criteria, or call us and one of the team will be happy to help.
            </p>
          </NoResults>
        )}
      </Results>
    )
  }
}

VehicleListingFilterResults.defaultProps = {
  vehicles: [],
  vehicleType: 'car',
  onInfoOpen: () => {},
  onRecentFavourite: () => {}
}
VehicleListingFilterResults.propTypes = {
  vehicles: array,
  vehicleType: string,
  onInfoOpen: func,
  onRecentFavourite: func
}

export default VehicleListingFilterResults
